import * as z from "zod/v4";
import { ProfileSchema } from "./profile.js";
const ListProfilesResponseSchema_ = z.object({
    profiles: z.array(ProfileSchema),
});
export const ListProfilesResponseSchema = ListProfilesResponseSchema_;
//# sourceMappingURL=list-profiles-response.js.map